<header id="header-wrap" class="main-header">
  <div class="header-inner">
    <a href="index.html" class="logo-link">
      <img src="assets/icon.png" alt="Atlegras Logo">
    </a>
    <h1 class="page-title">Articles</h1>
    <div class="spacer"></div>
  </div>
</header>

<main class="main-content">
  <section class="iq-page-blog">

    <!-- Article 1 -->
    <div class="iq-blog-box">
      <div class="iq-blog-image">
        <img src="assets/images/articles/ai-recommendations/ai-recommendations.jpg" alt="AI Recommendations">
      </div>
      <div class="iq-blog-detail">
        <div class="blog-title">
          <a href="/articles/ai-recomendations">
            <h5>Pose Like a Pro: AI’s Recommendations for Woman Standing Portraits.</h5>
          </a>
        </div>
        <div class="blog-button">
          <a href="/articles/ai-recomendations" class="btn">Read <span style="font-size: 16px; margin-left: 4px;">→</span>
          </a>
        </div>
      </div>
    </div>

    <!-- Article 2 -->
    <div class="iq-blog-box">
      <div class="iq-blog-image">
        <img src="assets/images/articles/trends/trends.jpg" alt="Trends">
      </div>
      <div class="iq-blog-detail">
        <div class="blog-title">
          <a href="/articles/trends">
            <h5>From Glamour to Lifestyle: Discovering Photography Style Trends Among Models and Photographers in Different Countries</h5>
          </a>
        </div>
        <div class="blog-button">
          <a href="/articles/trends" class="btn">Read <span style="font-size: 16px; margin-left: 4px;">→</span>
          </a>
        </div>
      </div>
    </div>

    <!-- Article 3 -->
    <div class="iq-blog-box">
      <div class="iq-blog-image">
        <img src="assets/images/articles/perfecting-daylight/perfecting-daylight.jpg" alt="Daylight Photography">
      </div>
      <div class="iq-blog-detail">
        <div class="blog-title">
          <a href="/articles/perfecting-daylight">
            <h5>Bringing Portraits to Life: Perfecting Daylight People Photography</h5>
          </a>
        </div>
        <div class="blog-button">
          <a href="/articles/perfecting-daylight" class="btn">Read <span style="font-size: 16px; margin-left: 4px;">→</span>
          </a>
        </div>
      </div>
    </div>
  </section>
</main>
